import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { EdpInputToogleModule } from "@edp-components/edp-input-toogle/edp-input-toogle.module";
import { TranslateModule } from "@ngx-translate/core";
import { EdpCommunicationsConsentsModalComponent } from "./edp-communications-consents-modal.component";

@NgModule({
    declarations: [EdpCommunicationsConsentsModalComponent],
    imports: [
        CommonModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        EdpInputToogleModule
    ],
    exports: [EdpCommunicationsConsentsModalComponent],
})
export class EdpCommunicationsConsentsModalModule {}
